/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Speed_SubtitleInputs */

const en_common_speed_subtitle = /** @type {(inputs: Common_Speed_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select playback speed`)
};

const es_common_speed_subtitle = /** @type {(inputs: Common_Speed_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajusta la reproducción`)
};

/**
* | output |
* | --- |
* | "Select playback speed" |
*
* @param {Common_Speed_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_speed_subtitle = /** @type {((inputs?: Common_Speed_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Speed_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_speed_subtitle(inputs)
	return en_common_speed_subtitle(inputs)
});